import { render } from "./CreateAppointmentLab.vue?vue&type=template&id=e6aa2d80&scoped=true"
import script from "./CreateAppointmentLab.vue?vue&type=script&lang=js"
export * from "./CreateAppointmentLab.vue?vue&type=script&lang=js"

import "./CreateAppointmentLab.vue?vue&type=style&index=0&id=e6aa2d80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6aa2d80"]])

export default __exports__